import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { Megaphone, X } from 'lucide-react';
import './RyanCampaignBanner.css';

interface EligibleCampaign {
  _id: string;
  title: string;
  message: string;
  ctaLabel: string;
  ctaSlug: string | null;
}

// Mostrado uma vez por carregamento da RyanHomePage — busca a campanha mais
// recente elegível pro usuário logado (período + segmentação has/lacks
// produto, já resolvidos no backend) e nunca mais mostra a mesma depois de
// dispensada (RyanCampaignDismissal). Mesmo padrão visual/portal já usado em
// RyanCompraModal (overlay centralizado via createPortal em document.body).
const RyanCampaignBanner: React.FC = () => {
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState<EligibleCampaign | null>(null);
  const [dismissing, setDismissing] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    fetch('/api/ryan/campanhas/ativas', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => (res.ok ? res.json() : null))
      .then(data => setCampaign(data?.campaign || null))
      .catch(() => setCampaign(null));
  }, []);

  if (!campaign) return null;

  const dismiss = () => {
    setCampaign(null);
    setDismissing(true);
    const token = localStorage.getItem('accessToken');
    fetch(`/api/ryan/campanhas/${campaign._id}/dispensar`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  };

  const handleCta = () => {
    dismiss();
    if (campaign.ctaSlug) navigate(`/ryan/produto/${campaign.ctaSlug}`);
  };

  if (dismissing) return null;

  return ReactDOM.createPortal(
    <div className="rcb-overlay" onClick={dismiss}>
      <div className="rcb-modal" onClick={e => e.stopPropagation()}>
        <button className="rcb-close-btn" onClick={dismiss} aria-label="Fechar">
          <X size={18} />
        </button>

        <div className="rcb-hero">
          <div className="rcb-icon-wrap">
            <Megaphone size={26} />
          </div>
        </div>

        <div className="rcb-body">
          <p className="rcb-eyebrow">Novidade pra você</p>
          <h2 className="rcb-title">{campaign.title}</h2>

          {campaign.message && (
            <div className="rcb-message-box">
              <p className="rcb-text">{campaign.message}</p>
            </div>
          )}

          <div className="rcb-actions">
            {campaign.ctaSlug && (
              <button className="rcb-btn-primary" onClick={handleCta}>
                {campaign.ctaLabel}
              </button>
            )}
            <button className="rcb-btn-secondary" onClick={dismiss}>
              Agora não
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RyanCampaignBanner;
